import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Discounts2: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.38462 1L14.0481 1.95192L15 8.61537L8.81249 14.8029C8.54964 15.0657 8.1235 15.0657 7.86058 14.8029L1.19715 8.13941C0.934283 7.87656 0.934283 7.45035 1.19715 7.1875L7.38462 1ZM7.86058 2.42788L2.62503 7.66345L8.33653 13.375L13.5721 8.13941L12.8582 3.14182L7.86058 2.42788ZM9.28852 6.71154C8.76275 6.1858 8.76275 5.33342 9.28852 4.80768C9.81421 4.28195 10.6666 4.28195 11.1923 4.80768C11.718 5.33342 11.718 6.1858 11.1923 6.71154C10.6666 7.23724 9.81421 7.23724 9.28852 6.71154Z"
        fill={color}
      />
    </svg>
  );
};

export default Discounts2;
